import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/Components/shadcn/dialog';
import { Button } from '@/Components/shadcn/button';
import UIStrings from '@/Utils/UIStrings';

interface ConfirmationDialogProps {
    open: boolean;
    title?: string;
    actionButtonText?: string;
    onConfirm?: () => void;
    onClose?: () => void;
    children?: React.ReactNode;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
    onConfirm,
    title,
    actionButtonText,
    children,
    open,
    onClose,
}) => {
    return (
        <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose?.()}>
            <DialogContent className="max-w-md">
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                </DialogHeader>
                <DialogDescription asChild>
                    <div>{children}</div>
                </DialogDescription>
                <DialogFooter className="flex gap-2">
                    <Button variant="outline" onClick={onClose}>
                        {UIStrings.Cancel}
                    </Button>
                    <Button variant="destructive" onClick={onConfirm}>
                        {actionButtonText}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default ConfirmationDialog;
